module.exports = __webpack_public_path__ + "media/images/pages/img_digest_facility_03-b5718650abd20522f2b14229335988b7.jpg";